export const initialState = {
    cartItems: [],
    orderId: null,
    orderNumber: null,
    products: [],
    isError: null,
    isPaySuceess: null,
    paymentMessage: "",
    getSavedCardListFromStripe: {},
    buyNowItems : []
};

export const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case "CARTITEMS":
            return {
                ...state,
                cartItems: [...action.payload]
            }
        case "BUYNOWITEMS":
            return {
                ...state,
                buyNowItems: [...action.payload]
            }
        case "PRODUCTCURRENTSTATUS":
            return {
                ...state,
                products: action.payload.data?.data ? action.payload.data?.data : [],
                isError: typeof action.payload.data.isError === "boolean" ? action.payload.data.isError : null,
            }
        case "CHECKOUT":
            return {
                ...state,
                orderId: action.payload.data.orderId,
                orderNumber: action.payload.data.orderNumber,
                products: action.payload.data?.data ? action.payload.data?.data : [],
                isPaySuceess: typeof action.payload.data.isPaySuceess === "boolean" ? action.payload.data.isPaySuceess : null,
                isError: typeof action.payload.data.isError === "boolean" ? action.payload.data.isError : null,
                paymentMessage: action.payload.data?.paymentMessage ? action.payload.data?.paymentMessage : ""
            }
        case 'GET_SAVED_CARD_LIST':
            return {
                ...state,
                getSavedCardListFromStripe: action.payload
            }
        case "ERROR":
            return {
                isError: true
            }
        default:
            return state
    }
}